import { PAGE_TITLES } from "@miplatform/constants";
import DispatchVerificationReview from "../../views/DispatchVerificationReview/DispatchVerificationReview";
import { Schedule } from "../../views/Schedule/Schedule";

export const dispatchRoutes = [
  {
    path: "/dispatch",
    name: "Dispatch",
    element: <Schedule />,
    handle: { title: PAGE_TITLES.DISPATCH },
  },
  {
    path: "/dispatch/review",
    name: "Dispatch Verification Review",
    element: <DispatchVerificationReview />,
    handle: { title: PAGE_TITLES.DISPATCH_VERIFICATION_REVIEW },
  },
  {
    path: "/dispatch/:id",
    name: "Dispatch",
    element: <Schedule />,
    handle: { title: PAGE_TITLES.DISPATCH },
  },
];
